import { Link } from 'gatsby'
import React from 'react'
import styled, { css } from 'styled-components'

import Pill from '../shared/Pill'
import { H2, P, getTypographyStyling } from '../shared/Typography'

const Container = styled.main`
  ${(p) =>
    p.$displayMode === 'grid' &&
    css`
      display: flex;
      flex-wrap: wrap;
      gap: 24px;
      padding: 24px;
      padding-right: 0;
    `};
  width: 100%;

  @media (min-width: ${(p) => p.theme.chameleon.breakpoints.lg}) {
    ${(p) =>
      p.$displayMode === 'grid' &&
      css`
        padding-top: 32px;
        padding-right: 0;
      `};
  }

  @media (min-width: ${(p) => p.theme.chameleon.breakpoints.xl}) {
    ${(p) =>
      p.$displayMode === 'grid' &&
      css`
        padding: 48px;
        padding-right: 0;
        gap: 48px;
      `};
  }
`
const ItemContainer = styled.div`
  border-bottom: 1px solid ${(p) => p.theme.chameleon.colors.pusher.borderColor};
  padding: 40px 0;

  :last-of-type {
    ${(p) =>
      p.$displayMode === 'list' &&
      css`
        border-bottom: none;
      `};
  }

  @media (min-width: ${(p) => p.theme.chameleon.breakpoints.md}) {
    margin: 0;
    padding: ${(p) => (p.$displayMode === 'grid' ? '16px' : '40px 0 40px 24px')};

    ${(p) =>
      p.$displayMode === 'grid' &&
      css`
        flex-basis: calc(50% - 24px);
        flex-grow: 1;
        flex-shrink: 1;
        width: 100%;
        border: 1px solid ${(p) => p.theme.chameleon.colors.pusher.borderColor};
        border-radius: 4px;
      `};
  }

  @media (min-width: ${(p) => p.theme.chameleon.breakpoints.xl}) {
    margin: 0;
    padding: ${(p) => (p.$displayMode === 'grid' ? '16px' : '40px 48px')};
  }
`
const Item = styled(Link)`
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;

  :hover {
    color: ${(p) => p.theme.chameleon.colors.pusher.mediumPurple};
  }

  ${(p) =>
    p.$displayMode === 'list' &&
    css`
      ::after {
        border-bottom: 1px solid ${(p) => p.theme.chameleon.colors.pusher.borderColor};
        bottom: -41px;
        left: -6vw;
        content: '';
        height: 0;
        width: 106vw;
        position: absolute;
      }

      @media (min-width: ${(p) => p.theme.chameleon.breakpoints.md}) {
        ::after {
          left: 0;
        }
      }
    `}
`
const ItemTitle = styled(H2)`
  ${getTypographyStyling('h4')}
  margin-bottom: 16px;

  ${(p) =>
    p.$displayMode === 'grid' &&
    css`
      font-size: 16px;
      line-height: 28px;
    `};
`
const ItemDescription = styled(P)``
const ItemFollow = styled(P)`
  font-weight: 600;
  border-bottom: 2px solid;
  padding-bottom: 1px;
  width: fit-content;
  margin-top: auto;
  margin-bottom: 0;
`
export const ItemTags = styled.div`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 16px;
  margin: 8px 0;
`
const TimeToRead = styled.p`
  font-weight: 600;
  margin: 16px 0;
`

const ArticlesList = ({ articles, displayMode }) => {
  const renderedArticles = articles.map(({ Slug, Title, Excerpt, MetaDescription, Body, Tags }) => {
    const tagsToRender = [...Tags]

    const renderedTags = tagsToRender.slice(0, 3).map(({ Name, Slug }) => (
      <Pill key={Slug} $isInverted={true}>
        {Name}
      </Pill>
    ))

    const timeToRead = Body.data.childMarkdownRemark.timeToRead

    return (
      <ItemContainer key={Slug} $displayMode={displayMode}>
        <Item to={`/tutorials/${Slug}`} $displayMode={displayMode}>
          <ItemTitle $displayMode={displayMode}>{Title}</ItemTitle>
          <ItemDescription>{Excerpt || MetaDescription}</ItemDescription>
          <ItemTags>
            {renderedTags} {tagsToRender.length > 3 && '...'}
          </ItemTags>
          <TimeToRead>{timeToRead} minute read</TimeToRead>
          <ItemFollow>Follow tutorial</ItemFollow>
        </Item>
      </ItemContainer>
    )
  })

  return <Container $displayMode={displayMode}>{renderedArticles}</Container>
}

export default ArticlesList
